import React from 'react';
import {
	Dialog,
	DialogContent,
	makeStyles,
	Grid,
	Box,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLoginModal } from '../../reducers/UiReducer';
import LoginForm from '../../form/LoginForm';

const useStyles = makeStyles((theme) => ({
	root: {
		backgroundColor: 'transparent',
		backdropFilter: 'blur(2px)',
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(3),
		[theme.breakpoints.down('xs')]: {
			top: theme.spacing(2.5),
		},
		color: theme.palette.grey[500],
	},
}));

const LoginModal = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { loginModal } = useSelector((state) => state.ui);
	const handleClose = () => {
		dispatch(toggleLoginModal(false));
	};
	return (
		<Dialog
			PaperProps={{
				style: {
					borderRadius: 12,
					maxWidth: 450,
				},
			}}
			TransitionProps={{
				style: { backgroundColor: 'transparent' },
			}}
			onClose={handleClose}
			aria-labelledby='customized-dialog-title'
			className={classes.root}
			open={loginModal}
			fullWidth={true}
			maxWidth={'xs'}>
			<DialogContent
				style={
					{
						// paddingBottom: 20,
						// paddingTop: 50,
						// padding: 0,
					}
				}>
				<Box
					onClick={handleClose}
					style={{ textAlign: 'end', cursor: 'pointer' }}>
					<i class='fa fa-times' aria-hidden='true'></i>
				</Box>
				<Box style={{ textAlign: 'center' }}>
					<span style={{ fontSize: 26 }}>Welcome to Musafir Bazar</span>
					<br />
					<span style={{ fontSize: 12, color: 'grey' }}>
						Please enter your email and password
					</span>
				</Box>
				<LoginForm />
			</DialogContent>
		</Dialog>
	);
};

export default LoginModal;
